import React from "react";
import { DroneDTO } from "../../../../../store/drone_slice";
import Title from "../../../../../common/title/title";
import Input from "../../../../../common/input_text/input_text";

interface AdvertisementFormProps {
  droneData: Partial<Omit<DroneDTO, "id">>;
  updateDroneData: (newData: Partial<Omit<DroneDTO, "id">>) => void;
}

const AdvertisementForm: React.FC<AdvertisementFormProps> = ({
  droneData,
  updateDroneData,
}) => {
  const handleNameChange = (value: string) => {
    updateDroneData({ name: value });
  };

  const handleBrandChange = (value: string) => {
    updateDroneData({ brand: value });
  };

  const handleModelChange = (value: string) => {
    updateDroneData({ model: value });
  };

  return (
    <div className="max-w-md mx-auto mt-8">
      <Title
        title="Let's name your advertisement"
        subtitle="Short and specific name will give the best results."
      />
      <Input
        value={droneData.name || ""}
        onChange={handleNameChange}
        placeholder="Example: Performing cartography drone services"
        maxLength={150}
      />

      <Title title="Let's choose the brand and model" subtitle="" />
      <div className="flex space-x-4">
        <div className="w-[30%]">
          <Input
            value={droneData.brand || ""}
            onChange={handleBrandChange}
            placeholder="Enter brand"
            maxLength={50}
          />
        </div>
        <div className="w-[70%]">
          <Input
            value={droneData.model || ""}
            onChange={handleModelChange}
            placeholder="Enter model"
            maxLength={50}
          />
        </div>
      </div>
    </div>
  );
};

export default AdvertisementForm;
